<div class="shadow-lg rounded">
  <div class="modal-header">
    <h4 class="modal-title mb-2">{{ configObj.title }}</h4>
    <button type="button" class="close dismiss" aria-label="Close" (click)="Onconfirmation('dismiss')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" [innerHTML]="configObj.message"></div>
  <div class="modal-footer">
    @if (configObj.btnCancelText) {
      <button type="button" class="gms-btn secondary"
        (click)="Onconfirmation('decline')">
        {{ configObj.btnCancelText}}
      </button>
    }
    <button type="button" class="gms-btn primary" (click)="Onconfirmation('accept')">
      {{ configObj.btnOkText }}
    </button>
  </div>
</div>